<template>
  <div>
    <v-tabs
        v-if="!id"
        show-arrows
        v-model="tab"
    >
      <v-tab v-for="tab in tabs" v-bind:key="tab.id">
        <v-icon class="mr-2">{{ tab.icon }}</v-icon>
        {{ tab.title }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-card-text>
        <v-alert
            v-if="tab === 0"
            border="bottom"
            colored-border
            type="info"
            elevation="2"
        >
          <div>Houve alterações na sua empresa?</div>
          <div>Informe os clientes sobre todas as alterações na sua empresa devido à COVID-19</div>
        </v-alert>

        <v-form
            ref="form"
            lazy-validation
            @submit="e => e.preventDefault()"
        >
          <upload-image
              v-if="tab !== 0"
              v-on:change="(file) => form.image = file"
              v-on:url-change="url => previewUrl = url"
              v-on:get-media-format="format => mediaFormat = format"
              :url="image"
              :media-format="mediaFormat"
          />

          <v-textarea
              v-if="tab === 0"
              v-model="form.summary"
              label="Atualizar seu status"
              required
              auto-grow
              outlined
          ></v-textarea>

          <v-textarea
              v-if="tab === 2"
              v-model="form.summary"
              label="Escrever postagem"
              required
              rows="1"
              outlined
          ></v-textarea>

          <!--Adicionar botao-->
          <div v-if="tab === 0 || tab === 2">
            <v-row>
              <v-col md="6" sm="12">
                <label class="pl-1" for="add-button">Adicione um botão (opcional)</label>
                <v-select
                    class="mt-2"
                    id="add-button"
                    v-model="form.actionButtonType"
                    :items="buttonsOptions"
                    item-text="text"
                    item-value="value"
                    menu-props="auto"
                    label="Adicione um botão (opcional)"
                    hide-details
                    single-line
                    outlined
                    color="primary"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="form.actionButtonType && form.actionButtonType !== ACTION_TYPE_CALL">
              <v-col md="12">
                <v-switch label="Utilizar url existente" v-model="useUrl"></v-switch>
              </v-col>
            </v-row>
            <v-row v-if="form.actionButtonType && form.actionButtonType !== ACTION_TYPE_CALL && !useUrl">
              <v-col md="12">
                <v-text-field
                    v-model="form.actionButtonLink"
                    label="Link para o botão"
                    hint="(exemplo: google.com.br)"
                    :rules="linkRules"
                    persistent-hint
                    required
                    outlined
                ></v-text-field>
              </v-col>
              <v-card-text class="py-0">Parametrização da url</v-card-text>
            </v-row>
            <v-row v-if="!useUrl && form.actionButtonType && form.actionButtonType !== ACTION_TYPE_CALL">
              <v-col md="4">
                <v-text-field
                    :disabled="!isValidUrl(form.actionButtonLink)"
                    dense
                    v-model="form.actionLinkUtmSource"
                    label="UTM Source"
                    hint="(exemplo: google)"
                    persistent-hint
                    outlined
                    @keyup="buildActionUrl"
                ></v-text-field>
              </v-col>
              <v-col md="4">
                <v-text-field
                    :disabled="!isValidUrl(form.actionButtonLink)"
                    dense
                    v-model="form.actionLinkUtmMedium"
                    label="UTM Medium"
                    hint="(exemplo: maps)"
                    persistent-hint
                    outlined
                    @keyup="buildActionUrl"
                ></v-text-field>
              </v-col>
              <v-col md="4">
                <v-text-field
                    :disabled="!isValidUrl(form.actionButtonLink)"
                    dense
                    v-model="form.actionLinkUtmCampaign"
                    label="UTM Campaign"
                    hint="(exemplo: campanha-01)"
                    persistent-hint
                    outlined
                    @keyup="buildActionUrl"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="form.actionButtonType && form.actionButtonType !== ACTION_TYPE_CALL && useUrl">
              <v-col md="4">
                <v-text-field
                    dense
                    hint="(exemplo: campanha)"
                    v-model="form.actionLinkParam"
                    label="Parametro"
                    persistent-hint
                    outlined />
              </v-col>
            </v-row>

            <v-row v-if="form.actionButtonType === ACTION_TYPE_CALL">
              <v-col md="6">
                <v-text-field
                    label="Número de telefone"
                    v-mask="'(##) ####-####?#'"
                    hint="Os clientes ligarão para este número"
                    v-model="locationPhone"
                    persistent-hint
                    disabled
                    required
                    outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <v-text-field
              v-if="tab === 3"
              v-model="form.title"
              label="Título do evento"
              hint="(Exemplo: Liquidação nesta semana)"
              persistent-hint
              required
              outlined
          ></v-text-field>

          <v-text-field
              v-if="tab === 1"
              v-model="form.title"
              label="Título da oferta"
              hint="(exemplo: 20% de desconto na loja on-line)"
              persistent-hint
              required
              outlined
          ></v-text-field>

          <div v-if="tab === 1 || tab === 3">
            <v-row>
              <v-col>
                <v-switch label="Adicionar hora" v-model="showTimes"></v-switch>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col :md="showTimes ? 8 : 12" :class="showTimes ? 'pr-2' : ''">
                <date-picker
                    label="Data de início"
                    no-icon
                    outlined
                    :value="form.openDate"
                    v-on:change="val => form.openDate = val"
                />
              </v-col>
              <v-col md="4" v-if="showTimes" class="pl-2">
                <v-autocomplete
                    label="Horário de início"
                    :items="timeOptions"
                    v-model="form.openTime"
                    outlined
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col :md="showTimes ? 8 : 12" :class="showTimes ? 'pr-2' : ''">
                <date-picker
                    label="Data de término"
                    no-icon
                    outlined
                    :value="form.closeDate"
                    v-on:change="val => form.closeDate = val"
                />
              </v-col>
              <v-col md="4" v-if="showTimes" class="pl-2">
                <v-autocomplete
                    label="Horário de término"
                    :items="timeOptions"
                    v-model="form.closeTime"
                    outlined
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row class="mb-2" no-gutters>
              <v-col md="4">
                <v-btn
                    small
                    text
                    @click="moreDetails = !moreDetails"
                >
                  Adicionar detalhes (opcional)
                  <v-icon>{{ moreDetails ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-expand-transition>
              <div v-show="moreDetails">
                <v-textarea
                    v-model="form.summary"
                    :label="`Detalhes ${tab === 3 ? 'do evento' : 'da oferta'}`"
                    required
                    outlined
                ></v-textarea>

                <v-text-field
                    v-if="tab !== 3"
                    v-model="form.offerCouponCode"
                    label="Código do cupom (opcional)"
                    outlined
                ></v-text-field>

                <v-text-field
                    v-if="tab !== 3"
                    v-model="form.offerRedeemOnlineUrl"
                    label="Link para resgatar a oferta (opcional)"
                    outlined
                ></v-text-field>

                <v-text-field
                    v-if="tab !== 3"
                    v-model="form.offerTermsAndConditions"
                    label="Termos e condições (opcional)"
                    outlined
                ></v-text-field>

                <!--Adicionar botao-->
                <div v-if="tab === 3">
                  <v-row>
                    <v-col md="6" sm="12">
                      <label class="pl-1" for="add-button">Adicione um botão (opcional)</label>
                      <v-select
                          class="mt-2"
                          id="add-button"
                          v-model="form.actionButtonType"
                          :items="buttonsOptions"
                          item-text="text"
                          item-value="value"
                          menu-props="auto"
                          label="Adicione um botão (opcional)"
                          hide-details
                          single-line
                          outlined
                          color="primary"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-row v-if="form.actionButtonType && form.actionButtonType !== ACTION_TYPE_CALL">
                    <v-col md="12">
                      <v-switch label="Utilizar url existente" v-model="useUrl"></v-switch>
                    </v-col>
                  </v-row>

                  <v-row v-if="form.actionButtonType && form.actionButtonType !== ACTION_TYPE_CALL && !useUrl">
                    <v-col md="12">
                      <v-text-field
                          v-model="form.actionButtonLink"
                          label="Link para o botão"
                          hint="(exemplo: google.com.br)"
                          :rules="linkRules"
                          persistent-hint
                          required
                          outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row v-if="form.actionButtonType && form.actionButtonType !== ACTION_TYPE_CALL && !useUrl">
                    <v-col md="4">
                      <v-card-text class="py-0">Parametrização da url</v-card-text>
                      <v-text-field
                          :disabled="!isValidUrl(form.actionButtonLink)"
                          dense
                          v-model="form.actionLinkUtmSource"
                          label="UTM Source"
                          hint="(exemplo: google)"
                          persistent-hint
                          outlined
                          @keyup="buildActionUrl"
                      ></v-text-field>
                    </v-col>
                    <v-col md="4">
                      <v-text-field
                          :disabled="!isValidUrl(form.actionButtonLink)"
                          dense
                          v-model="form.actionLinkUtmMedium"
                          label="UTM Medium"
                          hint="(exemplo: maps)"
                          persistent-hint
                          outlined
                          @keyup="buildActionUrl"
                      ></v-text-field>
                    </v-col>
                    <v-col md="4">
                      <v-text-field
                          :disabled="!isValidUrl(form.actionButtonLink)"
                          dense
                          v-model="form.actionLinkUtmCampaign"
                          label="UTM Campaign"
                          hint="(exemplo: campanha-01)"
                          persistent-hint
                          outlined
                          @keyup="buildActionUrl"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row v-if="form.actionButtonType && form.actionButtonType !== ACTION_TYPE_CALL && useUrl">
                    <v-col md="4">
                      <v-text-field
                          dense
                          hint="(exemplo: campanha)"
                          v-model="form.actionLinkParam"
                          label="Parametro"
                          persistent-hint
                          outlined />
                    </v-col>
                  </v-row>

                  <v-row v-if="form.actionButtonType === ACTION_TYPE_CALL">
                    <v-col md="6">
                      <v-text-field
                          label="Número de telefone"
                          v-mask="'(##) ####-####?#'"
                          hint="Os clientes ligarão para este número"
                          v-model="locationPhone"
                          persistent-hint
                          disabled
                          required
                          outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-expand-transition>
          </div>

          <schedule-form
              style="margin-top: 16px"
              v-if="bulkCreate"
              v-on:change="changeScheduleDate"
          />

          <v-row v-else-if="bulkUpdate" style="margin-top: 20px">
            <v-col md="4" class="pr-2">
              <date-picker
                  dense
                  label="Agendar para"
                  outlined
                  clearable
                  no-icon
                  v-on:change="date => form.schedule_start = date"
              />
            </v-col>
            <v-col md="4" class="pr-2">
              <v-text-field
                  dense
                  label="Horário de início"
                  outlined
                  clearable
                  v-on:change="date => form.schedule_start_at = date"
                  type="time"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-tabs-items>

    <v-card-actions>
      <v-spacer></v-spacer>
      <location-post-preview-modal
          :useUrl="useUrl"
          :location-phone="locationPhone"
          :location-name="locationName"
          :id="id"
          :title="form.title"
          :summary="form.summary"
          :action-button-link="form.actionButtonLink"
          :action-button-type="form.actionButtonType"
          :alert-type="getAlertType()"
          :event-schedule="''"
          :event-schedule-code="''"
          :offer-coupon-code="form.offerCouponCode"
          :offer-redeem-online-url="form.offerRedeemOnlineUrl"
          :offer-terms-and-conditions="form.offerTermsAndConditions"
          :created-at="createdAt"
          :type="type"
          :open-date="form.openDate"
          :open-time="form.openTime"
          :close-date="form.closeDate"
          :close-time="form.closeTime"
          :image="previewUrl"
          :media-format="mediaFormat"
      />
      <v-btn text color="primary" :loading="loading" @click="submit">Publicar</v-btn>
    </v-card-actions>

    <v-snackbar
        v-model="snackbar.show"
        timeout="3000"
        :color="snackbar.color"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker'
import {handleResponseError} from '@/api/handleError'
import * as postsConstants from '@/constants/posts'
import UploadImage from '@/components/UploadImage'
import LocationPostPreviewModal from '@/views/Locations/Modals/LocationPostPreviewModal'
import ScheduleForm from '@/views/Locations/Components/ScheduleForm'
import {TYPE_CREATE_LOCAL_POST, TYPE_UPDATE_LOCAL_POST} from '@/constants/tasks'

export default {
  name: 'LocationPostForm',
  components: {
    DatePicker,
    UploadImage,
    LocationPostPreviewModal,
    ScheduleForm
  },
  props: {
    bulkCreate: Boolean,
    bulkUpdate: Boolean,
    bulkParams: Object,
    locationName: {
      required: true,
      type: String
    },
    locationPhone: String,
    onUpdated: Function,
    onBulkUpdated: Function,
    id: Number,
    title: String,
    image: String,
    summary: String,
    propType: String,
    actionButtonType: String,
    actionButtonLink: String,
    createdAt: String,
    alertType: String,
    eventSchedule: String,
    eventScheduleCode: String,
    offerRedeemOnlineUrl: String,
    offerCouponCode: String,
    offerTermsAndConditions: String,
    openDate: String,
    openTime: String,
    closeDate: String,
    closeTime: String,
  },
  computed: {
    ACTION_TYPE_CALL: function() {
      return postsConstants.ACTION_TYPE_CALL
    }
  },
  data: () => ({
    useUrl: false,
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
    loading: false,
    showTimes: false,
    moreDetails: false,
    tab: 0,
    tabs: [
      { id: 0, title: 'Atualização da COVID-19', icon: 'mdi-alert' },
      { id: 1, title: 'Oferta', icon: 'mdi-tag' },
      { id: 2, title: 'Novidades', icon: 'mdi-alert-decagram' },
      { id: 3, title: 'Evento', icon: 'mdi-calendar' },
    ],
    buttonsOptions: [
      { text: 'Nenhum', value: '' },
      { text: 'Reservar', value: postsConstants.ACTION_TYPE_BOOK },
      { text: 'Fazer o pedido', value: postsConstants.ACTION_TYPE_ORDER },
      { text: 'Comprar', value: postsConstants.ACTION_TYPE_SHOP },
      { text: 'Saiba mais', value: postsConstants.ACTION_TYPE_LEARN_MORE },
      { text: 'Inscreva-se', value: postsConstants.ACTION_TYPE_SIGN_UP },
      { text: 'Ligar agora', value: postsConstants.ACTION_TYPE_CALL },
    ],
    form: {
      actionLinkParam: '',
      actionButtonType: '',
      actionButtonLink: '',
      summary: '',
      title: '',
      openDate: '',
      openTime: '',
      closeDate: '',
      closeTime: '',
      offerCouponCode: '',
      offerRedeemOnlineUrl: '',
      offerTermsAndConditions: '',
      details: '',
      image: '',
      actionLinkUtmSource: '',
      actionLinkUtmMedium: '',
      actionLinkUtmCampaign: '',
      schedule_start: '',
      schedule_start_at: '',
      schedule_end: '',
      schedule_end_at: '',
    },
    type: postsConstants.ALERT_TYPE,
    previewUrl: null,
    mediaFormat: null,
    statusRules: [
      v => !!v || 'O resumo não pode ficar vazio.',
    ],
    linkRules: [
      v => !!v || 'Insira um site válido (por exemplo: www.example.com)',
    ],
    timeOptions: []
  }),
  created() {
    this.timeOptions = this.generateOptions()
  },
  mounted() {
    this.tab = this.getTabByType(this.propType || postsConstants.ALERT_TYPE)
    this.showTimes = this.openTime || this.closeTime
    this.moreDetails = this.offerCouponCode || this.offerRedeemOnlineUrl || this.offerTermsAndConditions
    this.type = this.propType || postsConstants.ALERT_TYPE
    this.previewUrl = this.image
    this.form = {
      actionButtonType: this.actionButtonType,
      actionButtonLink: this.actionButtonLink,
      summary: this.summary,
      title: this.title,
      openDate: this.openDate,
      openTime: this.openTime,
      closeDate: this.closeDate,
      closeTime: this.closeTime,
      offerCouponCode: this.offerCouponCode,
      offerRedeemOnlineUrl: this.offerRedeemOnlineUrl,
      offerTermsAndConditions: this.offerTermsAndConditions,
      details: ''
    }
  },
  methods: {
    isValidUrl(url) {
      try {
        const newUrl = new URL(url);
        return newUrl.protocol === "http:" || newUrl.protocol === "https:"
      } catch (_) {
        return false
      }
    },
    buildActionUrl() {
      let url
      if(!this.useUrl) {
        url = new URL(this.form.actionButtonLink)
      } else {
        url = ''
      }
      let params = new URLSearchParams(url.search)

      if (this.form.actionLinkUtmSource) {
        params.set('utm_source', this.form.actionLinkUtmSource)
      } else {
        params.delete('utm_source')
      }
      if (this.form.actionLinkUtmMedium) {
        params.set('utm_medium', this.form.actionLinkUtmMedium)
      } else {
        params.delete('utm_medium')
      }
      if (this.form.actionLinkUtmCampaign) {
        params.set('utm_campaign', this.form.actionLinkUtmCampaign)
      } else {
        params.delete('utm_campaign')
      }

      if(!this.useUrl) {
        this.form.actionButtonLink = `${url.protocol}//${url.hostname}${url.pathname}?${decodeURI(params.toString())}`
      } else {
        this.form.actionButtonLink = `?${decodeURI(params.toString())}`
      }
    },
    typeHasField(type, field) {
      const ALERT_FIELDS = [
        'summary',
        'actionButtonType',
        'actionButtonLink'
      ]
      const OFFER_FIELDS = [
        'title',
        'openDate',
        'openTime',
        'closeDate',
        'closeTime',
        'offerCouponCode',
        'offerRedeemOnlineUrl',
        'offerTermsAndConditions',
        'details'
      ]
      const STANDARD_FIELDS = [
        'summary',
        'actionButtonType',
        'actionButtonLink'
      ]
      const EVENT_FIELDS = [
        'title',
        'openDate',
        'openTime',
        'closeDate',
        'closeTime',
        'offerCouponCode',
        'offerRedeemOnlineUrl',
        'offerTermsAndConditions',
        'details'
      ]

      switch (type) {
        case postsConstants.ALERT_TYPE: return ALERT_FIELDS.includes(field)
        case postsConstants.OFFER_TYPE: return OFFER_FIELDS.includes(field)
        case postsConstants.STANDARD_TYPE: return STANDARD_FIELDS.includes(field)
        case postsConstants.EVENT_TYPE: return EVENT_FIELDS.includes(field)
        default: return false
      }
    },
    clearValuesByType(type) {
      let newData = {}
      for (const field in this.form) {
        const canShow = this.typeHasField(type, field)
        if (canShow) newData[field] = this.form[field]
        else newData[field] = this[field]
      }
      this.form = newData
    },
    generateOptions() {
      const options = []
      for (let i = 0; i <= 24; i++) {
        options.push(`${i < 10 ? '0'+i : i}:00`)
        if (i < 24) options.push(`${i < 10 ? '0'+i : i}:30`)
      }
      return options
    },
    submit: async function() {
      if (!this.$refs.form.validate()) return

      let formData = new FormData()
      if (this.form.image) formData.append('media', this.form.image)
      formData.append('location_name', this.locationName || '')
      formData.append('topic_type', this.getTopicType())
      formData.append('alert_type', this.getAlertType())
      formData.append('language_code', 'pt-br')
      formData.append('summary', this.form.summary || '')
      formData.append('location_website_url_used', this.useUrl)
      formData.append('new_url_param', this.form.actionLinkParam || '')
      formData.append('action_type', this.form.actionButtonType || '')
      formData.append('action_url', this.form.actionButtonLink || '')
      formData.append('offer_coupon_code', this.form.offerCouponCode || '')
      formData.append('offer_redeem_online_url', this.form.offerRedeemOnlineUrl || '')
      formData.append('offer_terms_conditions', this.form.offerTermsAndConditions || '')
      formData.append('event_title', this.form.title || '')
      formData.append('event_start', this.form.openDate || '')
      formData.append('event_start_at', this.form.openTime || '')
      formData.append('event_end', this.form.closeDate || '')
      formData.append('event_end_at', this.form.closeTime || '')

      formData.append('schedule_type', this.bulkUpdate
          ? TYPE_UPDATE_LOCAL_POST
          : this.bulkCreate
              ? TYPE_CREATE_LOCAL_POST
              : '')
      formData.append('schedule_start', this.form.schedule_start || '')
      formData.append('schedule_end', this.form.schedule_end || '')
      formData.append('schedule_start_at', this.form.schedule_start_at || '')
      formData.append('schedule_end_at', this.form.schedule_end_at || '')

      this.loading = true
      try {
        if (this.bulkUpdate) {
          formData.append('_method', 'PUT')
          this.bulkParams.local_post_id = this.id
          formData.append('params', JSON.stringify(this.bulkParams))
          await this.$store.dispatch('posts/bulk', formData)
              .then(() => {
                this.showNotification('Atualização em massa enviada!', 'green darken-2')
                if (this.onBulkUpdated) {
                  this.onBulkUpdated()
                }
              })
              .catch(e => {
                const message = handleResponseError(e, 'Ocorreu um erro ao enviar os dados.')
                this.showNotification(message, 'red darken-2')
              })
        }
        else if (this.bulkCreate) {
          formData.append('_method', 'POST')
          formData.append('params', JSON.stringify(this.bulkParams))
          await this.$store.dispatch('posts/createBulk', formData)
              .then((res) => {
                this.showNotification('Atualização em massa enviada!', 'green darken-2')
                if (this.onBulkUpdated) this.onBulkUpdated(res.data)
              })
              .catch(e => {
                const message = handleResponseError(e, 'Ocorreu um erro ao enviar os dados.')
                this.showNotification(message, 'red darken-2')
              })
        }
        else if (this.id) {
          formData.append('_method', 'PUT')
          await this.$store.dispatch('posts/update', { id: this.id, data: formData })
              .then(() => {
                this.showNotification('Publicação atualizada!', 'green darken-2')
                if (this.onUpdated) this.onUpdated()
              })
              .catch(e => {
                const message = handleResponseError(e, 'Ocorreu um erro ao atualizar publicação.')
                this.showNotification(message, 'red darken-2')
              })
        }
        else {
          await this.$store.dispatch('posts/create', formData)
              .then(() => {
                this.showNotification('Publicação enviada!', 'green darken-2')
                if (this.onUpdated) this.onUpdated()
              })
              .catch(e => {
                const message = handleResponseError(e, 'Ocorreu um erro ao enviar os dados.')
                this.showNotification(message, 'red darken-2')
              })
        }
      } catch (e) {
        this.loading = false
        const message = handleResponseError(e, 'Ocorreu um erro ao enviar os dados.')
        this.showNotification(message, 'red darken-2')
      }
      this.loading = false
    },
    showNotification(message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    getTopicType() {
      if (this.tab === 0) return 'ALERT'
      if (this.tab === 1) return 'OFFER'
      if (this.tab === 2) return 'STANDARD'
      if (this.tab === 3) return 'EVENT'
    },
    getAlertType() {
      return this.tab === 0
          ? 'COVID_19'
          : ''
    },
    getTabByType(type) {
      if (type === postsConstants.ALERT_TYPE) return 0
      else if (type === postsConstants.OFFER_TYPE) return 1
      else if (type === postsConstants.STANDARD_TYPE) return 2
      else if (type === postsConstants.EVENT_TYPE) return 3
      return 0
    },
    changeScheduleDate(data) {
      this.form.schedule_start = data.schedule_start
      this.form.schedule_end = data.schedule_end
      this.form.schedule_start_at = data.schedule_start_at
      this.form.schedule_end_at = data.schedule_end_at
    }
  },
  watch: {
    tab: function(newTab) {
      if (newTab === 0) this.type = postsConstants.ALERT_TYPE
      else if (newTab === 1) this.type = postsConstants.OFFER_TYPE
      else if (newTab === 2) this.type = postsConstants.STANDARD_TYPE
      else if (newTab === 3) this.type = postsConstants.EVENT_TYPE

      this.clearValuesByType(this.type)
    },
    actionButtonType: function(value) {
      if (value === postsConstants.ACTION_TYPE_CALL || value === '') {
        this.form.actionButtonLink = ''
      }
    },
    showTimes: function(open) {
      if (!open) {
        this.form.openTime = ''
        this.form.closeTime = ''
      }
    }
  }
}
</script>

<style scoped>

</style>